<template>
    <div>
      <h5 v-html="$t('filter.titles.' + key)" />
      <el-date-picker class="p-0 w-100"
        v-model="selectedDates"
        type="monthrange"
        format="MMMM yyyy"
        :picker-options="pickerOptions"
        default-values="selectedDates"
        @input="transmitNewValue()"
      />
    </div>
  </template>
  
  <script>
  import moment from 'moment'
  export default {
    props: {
        default: { type: Object, default: () => {} }
    },
    data() {
      return {
        key: "period",
        pickerOptions: {
          disabledDate: this.disabledDueDate
        },
        selectedDates: []
      }
    },
    mounted() {
      this.selectedDates = [
        moment(this.default.period.start, 'MM-DD-YYYY').startOf('year'), 
        moment(this.default.period.end, 'MM-DD-YYYY')]
      this.transmitNewValue()
    },
    methods: {
      disabledDueDate(date) {
        return date >= moment(this.default.maxDate, 'MM-DD-YYYY').toDate() || date <= moment(this.default.minDate, 'MM-DD-YYYY').toDate()
      },
      transmitNewValue() {
        const formattedDates = [
          moment(this.selectedDates[0]).format('MM-DD-YYYY'),
          moment(this.selectedDates[1]).format('MM-DD-YYYY')
        ]
        this.$emit("transmit", formattedDates, this.key)
      }
    },
  }
  </script>
  
  <style lang="scss">
  .el-date-editor .el-range__icon {
    background: $colorbase-dark !important;
    color: white !important;
    width: 40px;
    border-radius: 5px 0 0 5px;
    margin-left: 0 !important;
  }
  </style>
  